<div class="container">
    <h2>Duplicate Orders Queue</h2>
    
    <nz-table
    [nzLoading]="loading"
    #basicTable
    [nzData]="duplicateOrders"
    (nzQueryParams)="onQueryParamsChange($event)"
  >
    <thead>
      <tr>
        <th nzColumnKey="order_id" [nzSortFn]="true">Account Number</th>
        <th nzColumnKey="first_name" [nzSortFn]="true">Customer Name</th>
        <th nzColumnKey="address_line_1" [nzSortFn]="true">Address</th>
        <th nzColumnKey="sale_date" [nzSortFn]="true">Sale Date</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of basicTable.data">
        <td>{{ order.order_id }}</td>
        <td>{{ order.first_name | titlecase }} {{ order.last_name | titlecase }}</td>
        <td>{{ order.address_line_1 }} {{ order.address_city }}, {{ order.address_state }} , {{ order.address_zip }}</td>
        <td>{{ order.sale_date | date }}</td>
        <td>
          <button nz-button nzType="primary" (click)="showResolveModal(order)">
            Resolve
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
  </div>

  <nz-modal
    [(nzVisible)]="isModalVisible"
    nzTitle="Resolve Duplicate Order"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
      <form>
        <nz-form-item>
          <nz-form-label>Duplicate Order Number</nz-form-label>
          <nz-form-control>
            <input nz-input [(ngModel)]="duplicateOrderNumber" name="duplicateOrderNumber" />
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>